module.exports = __webpack_public_path__ + "static/img/c4-2.afa61bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/c4-2.png
// module id = 879
// module chunks = 1